import {useState} from "react";

export default function useVideoData() {
  const [video, setVideo] = useState({});
  const [categoryVideos, setCategoryVideos] = useState([]);
  const [isLoading, setLoading] = useState(false);

  return {
    video, setVideo,
    categoryVideos, setCategoryVideos,
    isLoading, setLoading
  };
}